// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1%;
}
.contact__main .contact_heading {
  background-color: #fafafa;
  width: 90%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 5%;
}
.contact__main .contact_heading img {
  width: 40%;
}
.contact__main .contact_heading h2 {
  color: #e63b11;
  font-size: 3rem;
}
.contact__main .contact_heading a {
  color: #e63b11;
  font-weight: bold;
}
.contact__main .contact_heading .contact_heading_left {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 3rem;
}
.contact__main .contact_heading .contact_heading_left .button {
  background-color: #e63b11;
  color: #fff;
  text-transform: uppercase;
  border: none;
  border-radius: 1.5rem;
  font-size: medium;
  font-weight: 500;
  transition: 1s ease-in-out;
  padding: 1.5% 8%;
  cursor: pointer;
}
.contact__main .contact_heading .contact_heading_left .button:hover {
  background-color: #000;
}
.contact__main .contact_heading .contact_heading_left a {
  text-decoration: none;
  height: 3rem;
}
@media (max-width: 690px) {
  .contact__main .contact_heading {
    display: block;
  }
  .contact__main .contact_heading img {
    width: 100%;
  }
  .contact__main .contact_heading h2 {
    font-size: 2rem;
  }
  .contact__main .contact_heading .contact_heading_left {
    width: 100%;
    font-size: 1.2rem;
    text-align: justify;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .contact__main .contact_heading img {
    flex: 1 1;
    width: 50%;
  }
  .contact__main .contact_heading .contact_heading_left {
    margin-right: 5%;
    width: 100%;
    text-align: justify;
  }
  .contact__main .contact_heading h2 {
    text-align: center;
    font-size: 2.2rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .contact__main .contact_heading img {
    width: 50%;
  }
  .contact__main .contact_heading .contact_heading_left {
    margin-right: 2%;
    width: 100%;
    text-align: justify;
    font-size: 0.7rem;
  }
  .contact__main .contact_heading h2 {
    text-align: center;
    font-size: 1.5rem;
  }
}
.contact__main .contact_form {
  margin-top: 2%;
  margin-bottom: 2%;
  background-color: #fafafa;
  width: 90%;
  padding-bottom: 2%;
  align-content: center;
}
.contact__main .contact_form button {
  background-color: #e63b11;
  text-align: center;
  color: white;
  border: 1px solid black;
  border-radius: 20px;
  padding: 0.5%;
  width: 20%;
  margin-left: 40%;
  margin-top: 3%;
}
.contact__main .contact_form button:hover {
  background-color: white;
  transition: ease-in-out 0.5s;
  border: 1px solid #e63b11;
  color: #000;
}
@media (max-width: 690px) {
  .contact__main .contact_form {
    display: block;
    margin-bottom: 4%;
  }
  .contact__main .contact_form select {
    width: 100%;
    margin-top: 5%;
    margin-bottom: -20%;
  }
  .contact__main .contact_form .contact__text {
    margin: 3%;
  }
  .contact__main .contact_form button {
    margin: 5%;
    width: 90%;
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .contact__main .contact_form button {
    margin-left: 25%;
    width: 70%;
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
.contact__main .contact_form .contact__fields {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  margin: auto;
  flex-direction: row-reverse;
  display: block;
  align-content: center;
  font-weight: 600;
}
.contact__main .contact_form .contact__fields hr {
  border: 1px solid #e63b11;
  max-width: 100%;
  margin-left: 0;
}
.contact__main .contact_form .contact__fields h3 {
  font-weight: normal;
  font-size: 1.8rem;
  text-wrap: pretty;
  width: 100%;
}
.contact__main .contact_form .contact__fields input,
.contact__main .contact_form .contact__fields textarea,
.contact__main .contact_form .contact__fields select {
  background-color: #fafafa;
  border-right: none;
  border-bottom: 1px solid #000;
  border-left: none;
  border-top: none;
  padding: 3%;
}
.contact__main .contact_form .contact__fields input:focus {
  background-color: white;
}
.contact__main .contact_form .contact__fields select {
  width: 100%;
}
.contact__main .contact_form .contact__fields textarea {
  width: 100%;
}
.contact__main .contact_form .contact__fields input[type=email] {
  width: 100%;
  margin-bottom: 10%;
}
.contact__main .contact_form .contact__fields input[type=text] {
  width: 100%;
}
.contact__main .contact_form .contact__fields .contact__name {
  display: flex;
  margin-top: 5%;
  width: 100%;
  gap: 10%;
}
.contact__main .contact_form .contact__fields .contact__name .name_field {
  width: 100%;
  flex: 1 1;
}
@media (max-width: 690px) {
  .contact__main .contact_form .contact__fields {
    display: block;
    flex-direction: row-reverse;
    width: 100%;
  }
  .contact__main .contact_form .contact__fields select {
    font-weight: 100;
    width: 100%;
  }
  .contact__main .contact_form .contact__fields .contact__name {
    display: "flex";
    gap: 5%;
    margin-top: 12%;
    width: 100%;
    font-weight: 600;
  }
  .contact__main .contact_form .contact__fields .contact__name .name_field {
    width: 100%;
    flex: 1 1;
    font-weight: 600;
  }
  .contact__main .contact_form .contact__fields #selectLabel {
    font-weight: 600;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .contact__main .contact_form .contact__fields {
    width: 70%;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .contact__main .contact_form .contact__fields {
    width: 100%;
  }
}
.contact__main .contact_form .contact__icons {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 3%;
}
.contact__main .contact_form .contact__icons .contact__indivIcon {
  color: #000;
}
.contact__main .contact_form .contact__icons .contact__indivIcon:hover {
  transition: ease-in-out 0.5s;
  cursor: pointer;
  color: #e63b11;
}
.contact__main .contact_form .contact__options {
  align-content: center;
  width: 80%;
  margin: auto;
}
.contact__main .contact_form .contact__text {
  align-content: center;
  width: 80%;
  margin: auto;
}
.contact__main .contact_form .site__options {
  align-content: center;
  width: 100%;
  margin: auto;
}
@media (max-width: 690px) {
  .contact__main {
    padding: 1%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/contact.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAIA;EC4BI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED7BA,WAAA;AAAJ;AAEI;EACI,yBAPC;EAQD,UAAA;EC6DJ,aAAA;EACA,uBAAA;EACA,8BAAA;ED5DI,OAAA;AACR;AACQ;EACI,UAAA;AACZ;AAEQ;EACI,cCnBH;EDoBG,eAAA;AAAZ;AAGQ;EACI,cCxBH;EDyBG,iBAAA;AADZ;AAIQ;EACI,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAHZ;AAKY;EACI,yBCrCP;EDsCO,WAAA;EACA,yBAAA;EACA,YAAA;EAEA,qBAAA;EACA,iBAAA;EACA,gBAAA;EAGA,0BAAA;EACA,gBAAA;EACA,eAAA;AANhB;AAOgB;EACI,sBAAA;AALpB;AAQY;EACI,qBAAA;EACA,YAAA;AANhB;AAWQ;EAtDJ;IAuDQ,cAAA;EARV;EAUU;IACI,WAAA;EARd;EAWU;IACI,eAAA;EATd;EAYU;IACI,WAAA;IACA,iBAAA;IACA,mBAAA;EAVd;AACF;AAcQ;EACI;IACI,SAAA;IACA,UAAA;EAZd;EAeU;IAEI,gBAAA;IACA,WAAA;IACA,mBAAA;EAdd;EAkBU;IACI,kBAAA;IACA,iBAAA;EAhBd;AACF;AAmBQ;EACI;IACI,UAAA;EAjBd;EAoBU;IAEI,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,iBAAA;EAnBd;EAsBU;IACI,kBAAA;IACA,iBAAA;EApBd;AACF;AAyBI;EACI,cAAA;EACA,iBAAA;EACA,yBA3HC;EA4HD,UAAA;EACA,kBAAA;EACA,qBAAA;AAvBR;AAyBQ;EACI,yBClIH;EDmIG,kBAAA;EACA,YAAA;EAEA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAzBZ;AA4BQ;EACI,uBAAA;EACA,4BAAA;EACA,yBAAA;EACA,WAAA;AA1BZ;AA6BQ;EA7BJ;IA8BQ,cAAA;IACA,iBAAA;EA1BV;EA4BU;IACI,WAAA;IACA,cAAA;IACA,mBAAA;EA1Bd;EA6BU;IACI,UAAA;EA3Bd;EA8BU;IACI,UAAA;IACA,UAAA;IACA,eAAA;IACA,kBAAA;EA5Bd;AACF;AAgCQ;EAEI;IACI,gBAAA;IACA,UAAA;IACA,eAAA;IACA,kBAAA;EA/Bd;AACF;AAmCQ;EC5GJ,aAAA;EACA,mBAAA;EACA,uBAAA;ED4GQ,UAAA;EACA,YAAA;EACA,2BAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AA/BZ;AAiCY;EACI,yBAAA;EACA,eAAA;EACA,cAAA;AA/BhB;AAkCY;EACI,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAhChB;AAmCY;;;EAGI,yBAhNP;EAiNO,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAjChB;AAoCY;EACI,uBAAA;AAlChB;AAqCY;EACI,WAAA;AAnChB;AAsCY;EACI,WAAA;AApChB;AAuCY;EACI,WAAA;EACA,kBAAA;AArChB;AAwCY;EACI,WAAA;AAtChB;AAyCY;EACI,aAAA;EAEA,cAAA;EACA,WAAA;EACA,QAAA;AAxChB;AAyCgB;EACI,WAAA;EACA,SAAA;AAvCpB;AA2CY;EAlEJ;IAmEQ,cAAA;IACA,2BAAA;IACA,WAAA;EAxCd;EAyCc;IAEI,gBAAA;IACA,WAAA;EAxClB;EA0Cc;IACI,eAAA;IACA,OAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;EAxClB;EAyCkB;IACI,WAAA;IACA,SAAA;IACA,gBAAA;EAvCtB;EA0Cc;IAEI,gBAAA;EAzClB;AACF;AA4CY;EA7FJ;IA8FQ,UAAA;EAzCd;AACF;AA0CY;EAhGJ;IAiGQ,WAAA;EAvCd;AACF;AA2CQ;EC1OJ,aAAA;EACA,mBAAA;EACA,6BAAA;ED0OQ,UAAA;AAvCZ;AAyCY;EACI,WAAA;AAvChB;AAyCgB;EACI,4BAAA;EACA,eAAA;EACA,cCxSX;ADiQT;AA2CQ;EACI,qBAAA;EACA,UAAA;EACA,YAAA;AAzCZ;AA2CQ;EACI,qBAAA;EACA,UAAA;EACA,YAAA;AAzCZ;AA2CQ;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AAzCZ;AA6CI;EA1TJ;IA2TQ,WAAA;EA1CN;AACF","sourcesContent":["@import './variables.scss';\n\n$greyBg: #fafafa;\n\n.contact__main {\n    @include columnStartCenter;\n    padding: 1%;\n\n    .contact_heading {\n        background-color: $greyBg;\n        width: 90%;\n        @include rowBetweenStart;\n        // display: flex;\n        gap:5%;\n\n        img {\n            width: 40%;\n        }\n\n        h2 {\n            color: $orange;\n            font-size: 3rem;\n        }\n\n        a{ \n            color: $orange;\n            font-weight: bold;\n        }\n\n        .contact_heading_left {\n            width: 50%;\n            // flex:1;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            margin-right: 3rem;\n            // border:1px solid black;\n            .button{\n                background-color: $orange;\n                color: #fff;\n                text-transform: uppercase;\n                border: none;\n                // height: 3rem;\n                border-radius: 1.5rem;\n                font-size: medium;\n                font-weight: 500;\n                // letter-spacing: .2rem;\n                // margin: 3% auto;\n                transition: 1s ease-in-out;\n                padding: 1.5% 8%;\n                cursor: pointer;\n                &:hover{\n                    background-color: #000;\n                } \n            }\n            a{\n                text-decoration: none;\n                height: 3rem;\n            }  \n\n        }\n\n        @media(max-width: $mobile) {\n            display: block;\n\n            img {\n                width: 100%;\n            }\n\n            h2 {\n                font-size: 2rem;\n            }\n\n            .contact_heading_left {\n                width: 100%;\n                font-size: 1.2rem;\n                text-align: justify;\n                \n            }\n        }\n\n        @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n            img {\n                flex:1;\n                width: 50%;\n            }\n\n            .contact_heading_left {\n                // margin-left: 5%;\n                margin-right: 5%;\n                width: 100%;\n                text-align: justify;\n                // font-size: 0.7rem;\n            }\n\n            h2 {\n                text-align: center;\n                font-size: 2.2rem;\n            }\n        }\n\n        @media(min-width: $tabletMin) and (max-width: $tabletMax) {\n            img {\n                width: 50%;\n            }\n\n            .contact_heading_left {\n                // margin-left: 5%;\n                margin-right: 2%;\n                width: 100%;\n                text-align: justify;\n                font-size: 0.7rem;\n            }\n\n            h2 {\n                text-align: center;\n                font-size: 1.5rem;\n            }\n        }\n\n    }\n\n    .contact_form {\n        margin-top: 2%;\n        margin-bottom: 2%;\n        background-color: $greyBg;\n        width: 90%;\n        padding-bottom: 2%;\n        align-content: center;\n\n        button {\n            background-color: $orange;\n            text-align: center;\n            color: #ffff;\n            // border: none;\n            border: 1px solid black;\n            border-radius: 20px;\n            // font-size: 1.1rem;\n            padding: 0.5%;\n            width: 20%;\n            margin-left: 40%;\n            margin-top: 3%;\n        }\n\n        button:hover {\n            background-color: #ffff;\n            transition: ease-in-out 0.5s;\n            border: 1px solid $orange;\n            color: #000;\n        }\n\n        @media(max-width: $mobile) {\n            display: block;\n            margin-bottom: 4%;\n\n            select {\n                width: 100%;\n                margin-top: 5%;\n                margin-bottom: -20%;\n            }\n\n            .contact__text {\n                margin: 3%;\n            }\n\n            button {\n                margin: 5%;\n                width: 90%;\n                padding-top: 2%;\n                padding-bottom: 2%;\n            }\n\n        }\n\n        @media(min-width: $tabletMin) and (max-width: $tabletMax) {\n            // width:70%;\n            button {\n                margin-left: 25%;\n                width: 70%;\n                padding-top: 2%;\n                padding-bottom: 2%;\n            }\n        }\n        \n\n        .contact__fields {\n            @include rowCenter;\n            width: 50%;\n            margin: auto;\n            flex-direction: row-reverse;\n            display: block;\n            align-content: center;\n            font-weight: 600;\n\n            hr {\n                border: 1px solid $orange;\n                max-width: 100%;\n                margin-left: 0;\n            }\n\n            h3 {\n                font-weight: normal;\n                font-size: 1.8rem;\n                text-wrap: pretty;\n                width: 100%;\n            }\n\n            input,\n            textarea,\n            select {\n                background-color: $greyBg;\n                border-right: none;\n                border-bottom: 1px solid #000;\n                border-left: none;\n                border-top: none;\n                padding: 3%;\n            }\n\n            input:focus {\n                background-color: #ffff;\n            }\n\n            select {\n                width: 100%;\n            }\n\n            textarea {\n                width: 100%;\n            }\n\n            input[type=email] {\n                width: 100%;\n                margin-bottom: 10%;\n            }\n\n            input[type=text] {\n                width: 100%;\n            }\n\n            .contact__name {\n                display: flex;\n                // justify-content: space-between;\n                margin-top: 5%;\n                width: 100%;\n                gap:10%;\n                .name_field{\n                    width: 100%;\n                    flex:1;\n                }\n            }\n\n            @media(max-width: $mobile) {\n                display: block;\n                flex-direction: row-reverse;\n                width: 100%;\n                select {\n                    // margin-left:4%;\n                    font-weight: 100;\n                    width: 100%;\n                }\n                .contact__name {\n                    display:'flex';\n                    gap:5%;\n                    margin-top: 12%;\n                    width:100%;\n                    font-weight: 600;\n                    .name_field{\n                        width: 100%;\n                        flex:1;\n                        font-weight: 600;\n                    }\n                }\n                #selectLabel{\n                    // margin-left:5%;\n                    font-weight: 600;\n                }   \n\n            }\n            @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n                width:70%;\n            }\n            @media(min-width: $tabletMin) and (max-width: $tabletMax) {\n                width:100%;\n            }\n\n        }\n\n        .contact__icons {\n            @include rowEven;\n            margin: 3%;\n\n            .contact__indivIcon {\n                color: #000;\n\n                &:hover {\n                    transition: ease-in-out 0.5s;\n                    cursor: pointer;\n                    color: $orange;\n                }\n            }\n        }\n        .contact__options{\n            align-content: center;\n            width:80%;\n            margin: auto;\n        }\n        .contact__text{\n            align-content: center;\n            width:80%;\n            margin: auto;\n        }\n        .site__options{\n            align-content: center;\n            width:100%;\n            margin: auto;\n        }\n    }\n\n    @media(max-width: $mobile) {\n        padding: 1%;\n        \n    }\n\n}","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
